// src/consoleConfig.js
console.log = () => {};
console.warn = () => {};
console.error = () => {};